<template>
    <div v-if="session">
        <top-navbar padding="6" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row">
                <div class="col-11">
                    <session-header :session="session" :status-data="statusData" :status-colors="statusColors"></session-header>
                    <session-steps :session="session" current="observation"></session-steps>
                </div>
                <div class="col-1">
                </div>
            </div>
            <session-observation v-if="observations"
                :session="session"
                :log="log"
                :types="types"
                :competencies="competencies"
                :stats="stats"
                :observations="observations"
                @reload-session="loadSession"
                @reload-stats="loadStats"
            ></session-observation>
        </div>
    </div>
</template>

<script>
    import SessionFeatures from './sessions/SessionFeatures'
    import SessionHeader from './sessions/SessionHeader';
    import SessionSteps from './sessions/SessionSteps';
    import SessionObservation from './sessions/SessionObservation';

    export default {

        components: {
            SessionHeader, SessionSteps, SessionObservation
        },

        data() {
            return {
                statusData: [],
                statusColors: {},
                session: null,
                log: null,
                types: null,
                competencies: null,
                stats: null,
                observations: null,
                features: new SessionFeatures(this.$router, this.$auth),
                reloaderId: null,
           }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.sessions'),
                        route: '/socrates/ui/dashboard/sessions'
                    },
                    {
                        name: this.session.cohort.name + ' / ' + this.session.degree.name,
                        route: '/socrates/ui/dashboard/sessions/registrations/' + this.session.registration_id
                    },
                    {
                        name: this.session.learner.name,
                    },
                ]
            },

            canStartReloader() {
                return !this.session.sync && this.features.ownSession(this.session) && (this.session.status != 'closed' && this.session.status != 'archived')
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/sessions/' + to.params.id + '/observation', { params: {
                include: ['types', 'competencies', 'status_data', 'status_colors', 'rights']
            }})
            .then(resp => {
                next(vm => {
                    vm.session = resp.data.data
                    vm.types = resp.data.included.types
                    vm.competencies = resp.data.included.competencies
                    vm.statusData = resp.data.included.status_data
                    vm.statusColors = resp.data.included.status_colors
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.loadContent()
                    vm.loadStats()
                    vm.loadLog()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                } else if (err.response.status == 444) {
                    // This may happen if the connection fails with an online session.
                    next({ name: 'home' });
                }
            });
        },

        beforeDestroy() {
            this.clearReloader()
        },

        methods: {

            clearReloader() {
                if (this.reloaderId) {
                    clearInterval(this.reloaderId)
                }
            },

            initReloader() {
                if (!this.reloaderId && this.canStartReloader) {
                    this.reloaderId = setInterval(() => { this.loadSession() }, 3000)
                }
                if (this.reloaderId && !this.canStartReloader) {
                    clearInterval(this.reloaderId)
                    this.reloaderId = null
                }
            },

            loadSession() {
                axios.get('/socrates/api/front/dashboard/page/sessions/' + this.session.id + '/observation')
                .then(resp => {
                    this.session = resp.data.data

                    if (this.features.redirectOwnerIfSessionChanged(this.session)) {
                        return
                    }

                    this.initReloader()
                })
                .catch(err => {
                    if (err.response.status == 500) {
                        // Do nothing. This may happen occasionally.
                    } else if (err.response.status == 403) {
                        // The session may have been reset. Go back to the configuration page.
                        this.features.openConfiguration(this.session)
                    } else if (err.response.status == 444) {
                        // This may happen if the connection fails with an online session.
                        this.$router.push({ name: 'home'})
                    } else {
                        this.$auth.handleErrorVm(err, this)
                    }
                })        
            },

            loadContent() {
                axios.get('/socrates/api/front/dashboard/data/sessions/' + this.session.id + '/observation/content')
                .then(resp => {
                    this.observations = resp.data.data
                })
            },

            loadStats() {
                axios.get('/socrates/api/front/dashboard/data/sessions/' + this.session.id + '/observation/stats')
                .then(resp => {
                    this.stats = resp.data.data
                })
            },

            loadLog() {
                axios.get('/socrates/api/front/dashboard/data/sessions/' + this.session.id + '/observation/log')
                .then(resp => {
                    this.log = resp.data.data
                    this.$loader.hide()
                    this.initReloader()
                })
            },
        }
    }
</script>
